import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Printer, Image as ImageIcon, Zap } from 'lucide-react';
export function MirrorReveal() {
  return <section id="servicio" className="py-20 md:py-32 bg-ink relative overflow-hidden" data-id="element-361" data-mp="3etssec9cimet">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-362" data-mp="3tml4wuteth2p">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-363" data-mp="3osgvm4wo8wyg">
          {/* Left Column: Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-364" data-mp="6i58ac1mn9td">
            <div data-id="element-365" data-mp="2i7fxjdic2ucr">
              <h3 className="font-script text-3xl md:text-4xl text-gold mb-2" data-id="element-366" data-mp="2d6ryc4jyb77g">
                Permítenos presentarte algo diferente.
              </h3>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-cream leading-tight mb-6" data-id="element-367" data-mp="2l39h5vy25wck">
                Algo que está cambiando la forma en que las familias hispanas en
                Atlanta celebran.
              </h2>
            </div>

            <p className="text-2xl font-medium text-gold" data-id="element-368" data-mp="2yt39io8ruyr1">
              El Mirror Photo Booth — nuestro Espejo de los Recuerdos Eternos.
            </p>

            <div className="space-y-4 text-lg text-cream/80 font-light" data-id="element-369" data-mp="33uac88w257qu">
              <p data-id="element-370" data-mp="38p66lforo774">
                No es una cámara. No es un booth de cartón. No es tecnología
                genérica.
              </p>
              <p data-id="element-371" data-mp="3hrfgc3c7nwjg">
                Es un espejo interactivo de lujo con iluminación LED
                cinematográfica, diseñado para ser el centro elegante de
                cualquier evento.
              </p>
              <p data-id="element-372" data-mp="1nd4pxqfywubk">
                Tus invitados se acercan, tocan la pantalla, posan solos o en
                grupo — y en segundos tienen en sus manos una foto impresa de
                alta calidad, personalizada con el nombre de tu evento.
              </p>
            </div>

            <div className="bg-charcoal p-6 rounded-xl border border-gold/20 mt-8" data-id="element-373" data-mp="2zpa28ffomb53">
              <p className="text-xl text-cream font-medium mb-4" data-id="element-374" data-mp="2zmxajak4gmeu">
                El resultado: cada persona se va a su casa con un recuerdo
                físico de tu celebración.
              </p>
              <ul className="space-y-2 text-cream/80 font-light" data-id="element-375" data-mp="39l3c1r20nqj6">
                <li data-id="element-376" data-mp="34nto6fu9zmxg">• La abuela que vino de lejos.</li>
                <li data-id="element-377" data-mp="3jczipqi64oz0">• El primo que viajó de otro estado.</li>
                <li data-id="element-378" data-mp="3jfc124ru91cl">• Los amigos que nunca olvidan una buena fiesta.</li>
              </ul>
              <p className="text-gold font-serif text-xl mt-4 italic" data-id="element-379" data-mp="3eey2reg1h5rr">
                Todos se llevan un pedazo de tu historia.
              </p>
            </div>
          </motion.div>

          {/* Right Column: Illustration/Features */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-380" data-mp="avi5cff3a5tb">
            {/* Real Mirror Photo Booth Photo — blended into the dark area */}
            <div className="relative w-full max-w-md mx-auto aspect-[3/4] overflow-hidden" data-id="element-381" data-mp="3t1d6fc2kehkj">
              {/* Ambient gold glow behind the booth */}
              <div className="absolute inset-0 bg-gold/10 blur-[50px] rounded-full pointer-events-none" data-id="element-382" data-mp="3eds43kdikmdo"></div>

              <div className="relative w-full h-full" style={{
              WebkitMaskImage: 'radial-gradient(ellipse 75% 80% at 55% 55%, black 45%, transparent 95%)',
              maskImage: 'radial-gradient(ellipse 75% 80% at 55% 55%, black 45%, transparent 95%)'
            }} data-id="element-383" data-mp="3j8peaumj51s5">
                <img src="https://cdn.magicpatterns.com/uploads/nN5p4oKu2NHmAQezQMTVHT/photobooth_1.png" alt="Mirror Photo Booth de lujo — equipo real" loading="lazy" decoding="async" className="w-full h-full object-cover scale-[1.45]" style={{
                objectPosition: '78% 62%'
              }} data-id="element-384" data-mp="2xbcvmdum1bo8" />
              </div>
              {/* Soft dark vignette to fully merge with the page background */}
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-transparent pointer-events-none" data-id="element-385" data-mp="25jooq6ulphcs"></div>
              <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-ink/30 pointer-events-none" data-id="element-386" data-mp="7slyrjyela7q"></div>
            </div>

            {/* Feature Callouts */}
            <div className="absolute -right-4 top-1/4 bg-ink p-4 rounded-xl border border-gold/30 shadow-xl max-w-[200px] hidden md:block" data-id="element-387" data-mp="1lom0a37to9zs">
              <div className="flex items-center gap-3 mb-2" data-id="element-388" data-mp="1qmnjco5909b9">
                <Zap className="w-5 h-5 text-gold" data-id="element-389" data-mp="1vgjezjy1hk39" />
                <span className="font-semibold text-cream text-sm" data-id="element-390" data-mp="1vhuj5kvectuw">
                  Interactivo
                </span>
              </div>
              <p className="text-xs text-cream/70" data-id="element-391" data-mp="12rukw4veif10">
                Pantalla táctil completa con animaciones
              </p>
            </div>

            <div className="absolute -left-8 bottom-1/4 bg-ink p-4 rounded-xl border border-gold/30 shadow-xl max-w-[200px] hidden md:block" data-id="element-392" data-mp="17s0735iwj9bp">
              <div className="flex items-center gap-3 mb-2" data-id="element-393" data-mp="1gqu9jciwytx6">
                <Printer className="w-5 h-5 text-gold" data-id="element-394" data-mp="1go7rgiyecw0p" />
                <span className="font-semibold text-cream text-sm" data-id="element-395" data-mp="2n5uuyoabbtpi">
                  Al Instante
                </span>
              </div>
              <p className="text-xs text-cream/70" data-id="element-396" data-mp="2s7k7y9h3ihg8">
                Impresión profesional en segundos
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}